import type { ChangeEventHandler, FocusEvent, Ref } from 'react';
import classNames from 'classnames';
import * as styles from './Checkbox.module.scss';

export interface CheckboxProps {
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  label: string;
  name: string;
  checked?: boolean;
  'data-testid'?: string;
  className?: string;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  ref?: Ref<HTMLInputElement>;
}

const Checkbox = ({
  onChange,
  label,
  name,
  checked,
  'data-testid': dataTestId,
  className,
  onFocus,
  ref,
}: CheckboxProps) => {
  const id = `checkbox-${name}`;

  return (
    <label className={classNames(styles.label, className)} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className={styles.checkbox}
        onChange={onChange}
        data-testid={dataTestId}
        name={name}
        ref={ref}
        onFocus={onFocus}
        {...(checked !== undefined ? { checked } : {})}
      />
      <span className={styles.customCheckbox}></span>
      {label}
    </label>
  );
};

export default Checkbox;
